"use strict";
/*
 * Created on 11 02 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * ProductSiteBindingConverter
 *
 * @author JMe
 */


var ProductSiteBindingConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductSiteBindingConverter, _DataObjectConverter_);

  function ProductSiteBindingConverter() {
    _classCallCheck(this, ProductSiteBindingConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductSiteBindingConverter).apply(this, arguments));
  }

  return ProductSiteBindingConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductSiteBindingConverter = ProductSiteBindingConverter;